export const formRenderQualityCriteriaStyles = {
  FormControlContainer: {
    width: "30%",
    display: "flex",
  },
  FormControlContainerTextField: {
    m: 1,
    width: "15%",
  },
  Autocomplete: {
    width: "40vw",
    maxWidth: "calc(100% - 20px)",
    marginBottom: "24px",
    marginLeft: "24px",
    marginTop: "24px",
  },
  AutocompleteTags: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.5,
  },
  stickyOptionBox: {
    position: "sticky",
    top: "-1rem",
    background: "#fff",
    height: "60px",
    zIndex: "2",
    borderBottom: "1px solid",
  },
  checkboxOption: {
    marginRight: 8,
  },
  tooltipListItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "0.5rem",
    padding: "2px 0",
  },
};
